import { FC } from 'react';

import { Container } from './styled';

interface TooltipProps {
  title: string;
  className?: string;
}

const Tooltip: FC<TooltipProps> = ({ title, className, children }) => {
  return (
    <Container className={className}>
      {children}
      <span>{title}</span>
    </Container>
  );
};

export default Tooltip;
